/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  timeout util for async funcs
 */

interface TimeoutPromise<T> extends Promise<T> {
  clear?: () => void
}

export const timeoutAsync = async (delay = 0, shouldReject?: boolean) => {
  let timeoutId: NodeJS.Timeout | undefined
  let callback: () => void
  const promise: TimeoutPromise<void> = new Promise((resolve, reject) => {
    callback = shouldReject ? reject : resolve
    timeoutId = setTimeout(callback, delay)
  })
  promise.clear = () => {
    clearTimeout(timeoutId)
    callback?.()
  }
  return await promise
}

export const clearTimeoutAsync = (timeoutPromise: Promise<unknown> | TimeoutPromise<unknown>) => {
  if (timeoutPromise && 'clear' in timeoutPromise && typeof timeoutPromise.clear === 'function') {
    timeoutPromise.clear()
  }
}
